import React, {useState} from 'react';
import styled from 'styled-components';

import Row from "./../../../common/components/Row.js";
import Col from "./../../../common/components/Col.js";
import Card from "./../../../common/components/Card.js";
import Button from "./../../../common/components/Button.js";
import Typo from "./../../../common/components/Typo.js";
import Input from "./../../../common/components/Input.js";

const Error = styled.div.withConfig({displayName:'-Error'})`
  height: 30px;
  color: red;
`;

const FormEmailValidation = ({sessionUser, onConfirm, error}) => {
  const [email, setEmail] = useState(sessionUser && sessionUser.email ? sessionUser.email : '');
  const [code, setCode] = useState('');


  return (

    <Card>
      <Typo variant="h1">Email validation</Typo>
      <>
        {sessionUser.givenName ? 
          <>Hi {sessionUser.givenName}.<br /></>
        : null }  
        Validate your email.
      </>

      <Row>
        <Col widthmd="12">
          <Input
            label={"Email"}
            name="email"
            type="text"
            width="100%"
            value={email}
            onChange={(val) => setEmail(val)}
            required
          />
        </Col>
        <Col widthmd="12">
          <Input
            label={"Code"}
            name="code"
            type="text"
            width="100%"
            value={code}
            onChange={(val) => setCode(val)}
            required
          />
        </Col>
        <Col widthmd="12">
          <Button onClick={() => onConfirm({
            action: "email-validation",
            params: {
              email: email,
              code: code
            }
          })}>Confirm</Button>
        </Col>
        <Col widthmd="12">
          <Error>
            <br/>{error}<br/>
          </Error>
        </Col>
      </Row>
    </Card>
  )
}

export default FormEmailValidation;
